import {
  WHOLE_BODY_ENHANCED_SCREENING_SKU_ID,
  DEFAULT_SKU,
  SKU_370_ENABLED_LOCATIONS,
} from '@/constants';
import { SlotsOptions } from '@/types';
import {
  isBefore,
  parseISO,
  format,
  startOfMonth,
  getDate,
  getMonth,
  isValid,
  parse,
} from 'date-fns';

export const getFirstDateForEnhancedScreening = (locationId: string) => {
  return (
    SKU_370_ENABLED_LOCATIONS.find((l) => l.locationId === locationId)?.fistAvailableBookingDate ||
    format(new Date(), 'yyyy-MM-dd')
  );
};

export const isLocationAvailableForEnhancedScreening = (locationId: string) => {
  return SKU_370_ENABLED_LOCATIONS.map((location) => location.locationId).includes(locationId);
};

export const compareDateWithFirstAvailableBookingDate = (
  date: string | Date | undefined,
  skuID: number,
  locationId: string,
  returnType: 'date' | 'string' = 'date',
): string | Date | undefined => {
  if (!date) {
    const firstAvailableDate = getFirstDateForEnhancedScreening(locationId);
    if (skuID === WHOLE_BODY_ENHANCED_SCREENING_SKU_ID && firstAvailableDate) {
      return returnType === 'date' ? parseISO(firstAvailableDate) : firstAvailableDate;
    }
    return undefined;
  }

  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  const availableBookingDate = parseISO(
    getFirstDateForEnhancedScreening(locationId) || format(new Date(), 'yyyy-MM-dd'),
  );

  if (skuID === WHOLE_BODY_ENHANCED_SCREENING_SKU_ID) {
    const finalDate = isBefore(dateObj, availableBookingDate) ? availableBookingDate : dateObj;
    return returnType === 'date' ? finalDate : format(finalDate, 'yyyy-MM-dd');
  }

  return returnType === 'date' ? dateObj : format(dateObj, 'yyyy-MM-dd');
};

export const handleDefaultSku = (locationId: string, skus: any) => {
  const isEnableForEnhandedScreening = SKU_370_ENABLED_LOCATIONS.map(
    (location) => location.locationId,
  ).includes(locationId);
  let defaultSku;
  if (isEnableForEnhandedScreening) {
    defaultSku = skus?.find(
      (sku: any) => Number(sku.skuID) === WHOLE_BODY_ENHANCED_SCREENING_SKU_ID,
    );
  } else {
    defaultSku = skus?.find((sku: any) => Number(sku.skuID) === DEFAULT_SKU);
  }

  return defaultSku;
};

export const getDateToQuerySlots = (
  options: SlotsOptions,
  date: Date | undefined,
  skuId: number,
  locationId: string,
) => {
  const payloadDate = options?.date || (date ? format(date, 'yyyy-MM-dd') : undefined);
  const isBeforeCurrentMonth =
    payloadDate && isBefore(new Date(payloadDate), startOfMonth(new Date()));
  if (isBeforeCurrentMonth) {
    return undefined;
  }

  return payloadDate;
};
